import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Dropdown from 'react-bootstrap/Dropdown';
import ConfirmationDialogV2 from '../Elements/ConfirmationDialog/ConfirmationDialogV2';

import {
  useLocations,
  useChangeDefaultLocation,
  useDeleteLocation,
} from '@/features/location/api/locationRequests';
import storage from '@/utils/storage';
import { useAuth } from '@/lib/auth';
import { Business } from '@/features/business';

import UserIcon from '@/assets/img/user-default-icon.png';
import { ReactComponent as LogoutIcon } from '@/assets/img/logout-icon.svg';
import { ReactComponent as DeleteIcon } from '@/assets/img/delete-icon.svg';
import { ReactComponent as AddIcon } from '@/assets/img/add-icon-v2.svg';
import { SUPER_ADMIN_ROLE } from '@/config';
import { useTranslation } from 'react-i18next';

export const LocationDropDown = () => {
  const navigate = useNavigate();
  const { logout, user } = useAuth();
  const updateLocationMutation = useChangeDefaultLocation();
  const updatedeleteLocationMutation = useDeleteLocation();
  const locations = useLocations();
  const [deleteStore, setDeleteStore] = useState<Business>();
  const [storeList, setStoreList] = useState<Business[]>();
  const [selectedStore, setSelectedStore] = useState<Business>();
  const { t, i18n } = useTranslation();
  useEffect(() => {
    if (locations && locations.data && locations.data.list) {
      const data = [] as any;
      locations.data.list.map((location) => {
        if (location.id == storage.getKey('activeLocationId')) {
          data.push(location);
          if (location.name) {
            setSelectedStore(location);
          }
        } else {
          data.push(location);
        }
      });

      setStoreList(data);
    }
  }, [locations.data]);
  const onLocationSelect = async (business: Business) => {
    if (business && business.id != storage.getKey('activeLocationId')) {
      const businessId = business.id ? business.id : '';
      await updateLocationMutation.mutateAsync({ locationId: businessId });
      storage.setKey('activeLocationId', businessId);
      setSelectedStore(business);
      window.location.reload();
    }
  };
  const addNewStore = () => {
    navigate('/new-location');
  };
  const onDeleteStoreConfirm = () => {
    if (deleteStore && deleteStore.id) {
      setDeleteStore(undefined);
      updatedeleteLocationMutation.mutateAsync({ locationId: parseInt(deleteStore?.id) });
    }
  };

  const onDeleteStore = (e: any, store: Business) => {
    e.preventDefault();
    e.stopPropagation();
    setDeleteStore(store);
  };
  const isSuperAdmin = user?.businessUserRole?.name === SUPER_ADMIN_ROLE;
  return (
    <div>
      <Dropdown className="white header-menu location-dropdown">
        <Dropdown.Toggle>
          <img
            className="user-logo-icon"
            src={selectedStore?.businessImageUrl ? selectedStore?.businessImageUrl : UserIcon}
          />
        </Dropdown.Toggle>

        <Dropdown.Menu align={'end'}>
          {!isSuperAdmin &&
            storeList?.map((cl, index) => (
              <Dropdown.Item
                className={`${selectedStore && cl.id == selectedStore.id ? 'selected' : ''}`}
                key={`location-${index}`}
                onClick={() => onLocationSelect(cl)}
              >
                <div className="location-options">
                  <div className="location-left">
                    <span className="business-img">
                      <img src={cl.businessImageUrl ? cl.businessImageUrl : UserIcon} />
                    </span>
                    <div className="business-details">
                      <h5>{cl.name}</h5>
                      <span>{cl.address}</span>
                    </div>
                  </div>
                  <DeleteIcon className="delete-icon" onClick={(e) => onDeleteStore(e, cl)} />
                </div>
              </Dropdown.Item>
            ))}
          {!isSuperAdmin && user && user?.isAdmin && (
            <Dropdown.Item className="add-new-location" onClick={addNewStore}>
              <div className="add-location">
                <AddIcon /> <span>{t('Add a new store')}</span>
              </div>
            </Dropdown.Item>
          )}
          <hr />
          <Dropdown.Item onClick={() => logout()}>
            <div className="logout">
              <span className="icon-holder">
                <LogoutIcon />
              </span>{' '}
              <span>{t('Logout')}</span>
            </div>
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
      <ConfirmationDialogV2
        title="Delete Store?"
        description={`Are you sure you want to delete ${deleteStore ? deleteStore.name : 'this store'
          }`}
        onCancel={() => {
          setDeleteStore(undefined);
        }}
        yesButtonLabel="Yes, Confirm"
        noButtonLabel="No, Not Now"
        onConfirm={onDeleteStoreConfirm}
        open={deleteStore ? true : false}
      ></ConfirmationDialogV2>
    </div>
  );
};
